export default [
    {
        value: "Alimentacao",
        text: "Alimentação"
    },
    {
        value: "Hospedagem",
        text: "Hospedagem"
    },
    {
        value: "Passagem",
        text: "Passagem"
    },
    {
        value: "Translado",
        text: "Translado"
    },
    {
        value: "Outros",
        text: "Outros"
    }
]